const InputFieldLabel = ({ className, label, isRequired }) => {
  return (
    <p className={"text-base " + className}>
      {label} {isRequired ? <span className="text-red">*</span> : <></>}
    </p>
  );
};

export default InputFieldLabel;